import { render, staticRenderFns } from "./AreaChooser.vue?vue&type=template&id=d18dcae0&"
import script from "./AreaChooser.vue?vue&type=script&lang=js&"
export * from "./AreaChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports